import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wifi-solutions',
  templateUrl: './wifi-solutions.component.html',
  styleUrls: ['./wifi-solutions.component.css']
})
export class WifiSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
